import admin from './admin';
import contentApi from './content-api';

export const routes = {
  admin,
  'content-api': contentApi,
};
